import { PERMISSIONS } from 'contexts/PermissionsContext';

export const LOCAL_STORAGE_KEY = 'BUDGET_PERFORMANCE';
export const PERIOD_KEY = 'MonthNumber';

export const PLAN_AND_TRACK_NAV_CONFIG = [
	{
		name: 'Initiatives',
		label: 'Initiatives',
		path: '/initiatives/categories',
		requiredSome: [PERMISSIONS.InitiativesRead],
		disabled: false,
	},
	{
		name: 'waves',
		label: 'Wave Planning',
		path: '/waves',
		requiredSome: [PERMISSIONS.WavesRead],
		disabled: false,
	},
	{
		name: 'savings-tracker',
		label: 'Savings Tracker',
		path: '/budget',
		requiredSome: [PERMISSIONS.BudgetRead],
		disabled: false,
	},
];
